import { useTranslation } from 'react-i18next';
import { useSiteSettings } from '@/hooks/useSiteSettings';

export default function CtaSection() {
  const { t } = useTranslation('home');
  const { settings } = useSiteSettings();

  return (
    <section className="relative w-full overflow-hidden bg-ink-800">
      {settings.homeCtaImage && (
        <img
          src={settings.homeCtaImage}
          alt="CTA background"
          className="absolute inset-0 w-full h-full object-cover object-top"
        />
      )}

      <div className="relative flex items-center justify-center p-8 md:p-12 lg:p-16">
        <div className="max-w-2xl text-center">
          <span className="text-xs font-medium text-warm-500 uppercase tracking-[0.15em] mb-4 block">
            {t('cta.label') || 'Enterprise Solutions'}
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-bold text-ink-900 leading-snug mb-4 md:mb-6">
            {t('cta.title') || 'Dedicated support for large-scale procurement'}
          </h2>
          <p className="text-sm md:text-base text-ink-700 leading-relaxed mb-8 md:mb-10">
            {t('cta.desc') || 'Our account managers assist with custom specifications, bulk negotiations, and end-to-end logistics. From initial inquiry to final delivery, we manage your sourcing workflow.'}
          </p>
          <a
            href="/contact"
            className="inline-flex items-center gap-2 px-6 py-3 bg-warm-500 text-white text-sm font-medium hover:bg-warm-600 transition-colors whitespace-nowrap"
          >
            {t('cta.button') || 'Contact Sales'}
            <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}